/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetOwnership } from './AssetOwnership';
import {
    AssetOwnershipFromJSON,
    AssetOwnershipFromJSONTyped,
    AssetOwnershipToJSON,
    AssetOwnershipToJSONTyped,
} from './AssetOwnership';
import type { SystemBoundaryEntity } from './SystemBoundaryEntity';
import {
    SystemBoundaryEntityFromJSON,
    SystemBoundaryEntityFromJSONTyped,
    SystemBoundaryEntityToJSON,
    SystemBoundaryEntityToJSONTyped,
} from './SystemBoundaryEntity';

/**
 * Asset data
 * @export
 * @interface AssetEntity
 */
export interface AssetEntity {
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssetEntity
     */
    discoveredAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetEntity
     */
    lastSeenAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetEntity
     */
    decommissionedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    status?: AssetEntityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    version?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssetEntity
     */
    extendedAttributes?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof AssetEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    goldenRecordId?: string;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    openVulnCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    openVulnCritical?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    openVulnHigh?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    openVulnMedium?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    openVulnLow?: number;
    /**
     * 
     * @type {Date}
     * @memberof AssetEntity
     */
    openVulnCountUpdatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    openWeaknessCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    openWeaknessCritical?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    openWeaknessHigh?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    openWeaknessMedium?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    openWeaknessLow?: number;
    /**
     * 
     * @type {Date}
     * @memberof AssetEntity
     */
    openWeaknessCountUpdatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    assetTag?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    cloudInstanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    cloudResourceId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetEntity
     */
    ipAddresses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetEntity
     */
    macAddresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    hostname?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetEntity
     */
    hostnames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    fqdn?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetEntity
     */
    dnsNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    assetType?: AssetEntityAssetTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    cloudResourceType?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    cloudServiceKind?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssetEntity
     */
    cloudServiceConfig?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    applicationGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    hierarchyPath?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    saasTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    saasSubscriptionId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    saasEdition?: string;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    saasLicenseCount?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    saasServiceType?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    osName?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    osVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    osFamily?: AssetEntityOsFamilyEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    architecture?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    manufacturer?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    hardwareVendor?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    hardwareUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    deviceCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    deviceSubtype?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    firmwareVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    deviceRole?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssetEntity
     */
    networkDeviceConfig?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    geographicRegion?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    datacenter?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    environment?: AssetEntityEnvironmentEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    owner?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    ownerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    department?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    costCenter?: string;
    /**
     * 
     * @type {AssetOwnership}
     * @memberof AssetEntity
     */
    ownership?: AssetOwnership;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    cloudProvider?: AssetEntityCloudProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    cloudRegion?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    cloudAvailabilityZone?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    cloudInstanceType?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AssetEntity
     */
    cloudTags?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    riskScore?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    complianceStatus?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssetEntity
     */
    lastScanDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    criticalityLevel?: AssetEntityCriticalityLevelEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssetEntity
     */
    businessImpact?: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    compositeRiskScore?: number;
    /**
     * 
     * @type {Date}
     * @memberof AssetEntity
     */
    riskScoreCalculatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    parentAssetId?: string;
    /**
     * 
     * @type {SystemBoundaryEntity}
     * @memberof AssetEntity
     */
    systemBoundary?: SystemBoundaryEntity;
    /**
     * 
     * @type {Set<SystemBoundaryEntity>}
     * @memberof AssetEntity
     */
    additionalBoundaries?: Set<SystemBoundaryEntity>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssetEntity
     */
    assetAttributes?: { [key: string]: any; };
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetEntity
     */
    containerIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetEntity
     */
    vulnerabilityIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AssetEntity
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetEntity
     */
    decommissioned?: boolean;
}


/**
 * @export
 */
export const AssetEntityStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Decommissioned: 'DECOMMISSIONED',
    Deleted: 'DELETED'
} as const;
export type AssetEntityStatusEnum = typeof AssetEntityStatusEnum[keyof typeof AssetEntityStatusEnum];

/**
 * @export
 */
export const AssetEntityAssetTypeEnum = {
    Physical: 'PHYSICAL',
    Virtual: 'VIRTUAL',
    Container: 'CONTAINER',
    CloudCompute: 'CLOUD_COMPUTE',
    CloudStorage: 'CLOUD_STORAGE',
    CloudDatabase: 'CLOUD_DATABASE',
    CloudSecurity: 'CLOUD_SECURITY',
    CloudNetworking: 'CLOUD_NETWORKING',
    CloudComputeService: 'CLOUD_COMPUTE_SERVICE',
    CloudIdentity: 'CLOUD_IDENTITY',
    CloudMonitoring: 'CLOUD_MONITORING',
    CloudSaas: 'CLOUD_SAAS',
    CloudOther: 'CLOUD_OTHER'
} as const;
export type AssetEntityAssetTypeEnum = typeof AssetEntityAssetTypeEnum[keyof typeof AssetEntityAssetTypeEnum];

/**
 * @export
 */
export const AssetEntityOsFamilyEnum = {
    Windows: 'WINDOWS',
    Linux: 'LINUX',
    Macos: 'MACOS',
    Other: 'OTHER'
} as const;
export type AssetEntityOsFamilyEnum = typeof AssetEntityOsFamilyEnum[keyof typeof AssetEntityOsFamilyEnum];

/**
 * @export
 */
export const AssetEntityEnvironmentEnum = {
    Production: 'PRODUCTION',
    Staging: 'STAGING',
    Development: 'DEVELOPMENT'
} as const;
export type AssetEntityEnvironmentEnum = typeof AssetEntityEnvironmentEnum[keyof typeof AssetEntityEnvironmentEnum];

/**
 * @export
 */
export const AssetEntityCloudProviderEnum = {
    Aws: 'AWS',
    Azure: 'AZURE',
    Gcp: 'GCP',
    Other: 'OTHER'
} as const;
export type AssetEntityCloudProviderEnum = typeof AssetEntityCloudProviderEnum[keyof typeof AssetEntityCloudProviderEnum];

/**
 * @export
 */
export const AssetEntityCriticalityLevelEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Unknown: 'UNKNOWN'
} as const;
export type AssetEntityCriticalityLevelEnum = typeof AssetEntityCriticalityLevelEnum[keyof typeof AssetEntityCriticalityLevelEnum];


/**
 * Check if a given object implements the AssetEntity interface.
 */
export function instanceOfAssetEntity(value: object): value is AssetEntity {
    return true;
}

export function AssetEntityFromJSON(json: any): AssetEntity {
    return AssetEntityFromJSONTyped(json, false);
}

export function AssetEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'discoveredAt': json['discoveredAt'] == null ? undefined : (new Date(json['discoveredAt'])),
        'lastSeenAt': json['lastSeenAt'] == null ? undefined : (new Date(json['lastSeenAt'])),
        'decommissionedAt': json['decommissionedAt'] == null ? undefined : (new Date(json['decommissionedAt'])),
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'status': json['status'] == null ? undefined : json['status'],
        'version': json['version'] == null ? undefined : json['version'],
        'extendedAttributes': json['extendedAttributes'] == null ? undefined : json['extendedAttributes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'goldenRecordId': json['goldenRecordId'] == null ? undefined : json['goldenRecordId'],
        'openVulnCount': json['openVulnCount'] == null ? undefined : json['openVulnCount'],
        'openVulnCritical': json['openVulnCritical'] == null ? undefined : json['openVulnCritical'],
        'openVulnHigh': json['openVulnHigh'] == null ? undefined : json['openVulnHigh'],
        'openVulnMedium': json['openVulnMedium'] == null ? undefined : json['openVulnMedium'],
        'openVulnLow': json['openVulnLow'] == null ? undefined : json['openVulnLow'],
        'openVulnCountUpdatedAt': json['openVulnCountUpdatedAt'] == null ? undefined : (new Date(json['openVulnCountUpdatedAt'])),
        'openWeaknessCount': json['openWeaknessCount'] == null ? undefined : json['openWeaknessCount'],
        'openWeaknessCritical': json['openWeaknessCritical'] == null ? undefined : json['openWeaknessCritical'],
        'openWeaknessHigh': json['openWeaknessHigh'] == null ? undefined : json['openWeaknessHigh'],
        'openWeaknessMedium': json['openWeaknessMedium'] == null ? undefined : json['openWeaknessMedium'],
        'openWeaknessLow': json['openWeaknessLow'] == null ? undefined : json['openWeaknessLow'],
        'openWeaknessCountUpdatedAt': json['openWeaknessCountUpdatedAt'] == null ? undefined : (new Date(json['openWeaknessCountUpdatedAt'])),
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'assetTag': json['assetTag'] == null ? undefined : json['assetTag'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'cloudInstanceId': json['cloudInstanceId'] == null ? undefined : json['cloudInstanceId'],
        'cloudResourceId': json['cloudResourceId'] == null ? undefined : json['cloudResourceId'],
        'ipAddresses': json['ipAddresses'] == null ? undefined : json['ipAddresses'],
        'macAddresses': json['macAddresses'] == null ? undefined : json['macAddresses'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'hostnames': json['hostnames'] == null ? undefined : json['hostnames'],
        'fqdn': json['fqdn'] == null ? undefined : json['fqdn'],
        'dnsNames': json['dnsNames'] == null ? undefined : json['dnsNames'],
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'assetType': json['assetType'] == null ? undefined : json['assetType'],
        'cloudResourceType': json['cloudResourceType'] == null ? undefined : json['cloudResourceType'],
        'cloudServiceKind': json['cloudServiceKind'] == null ? undefined : json['cloudServiceKind'],
        'cloudServiceConfig': json['cloudServiceConfig'] == null ? undefined : json['cloudServiceConfig'],
        'applicationGroupId': json['applicationGroupId'] == null ? undefined : json['applicationGroupId'],
        'hierarchyPath': json['hierarchyPath'] == null ? undefined : json['hierarchyPath'],
        'saasTenantId': json['saasTenantId'] == null ? undefined : json['saasTenantId'],
        'saasSubscriptionId': json['saasSubscriptionId'] == null ? undefined : json['saasSubscriptionId'],
        'saasEdition': json['saasEdition'] == null ? undefined : json['saasEdition'],
        'saasLicenseCount': json['saasLicenseCount'] == null ? undefined : json['saasLicenseCount'],
        'saasServiceType': json['saasServiceType'] == null ? undefined : json['saasServiceType'],
        'osName': json['osName'] == null ? undefined : json['osName'],
        'osVersion': json['osVersion'] == null ? undefined : json['osVersion'],
        'osFamily': json['osFamily'] == null ? undefined : json['osFamily'],
        'architecture': json['architecture'] == null ? undefined : json['architecture'],
        'manufacturer': json['manufacturer'] == null ? undefined : json['manufacturer'],
        'model': json['model'] == null ? undefined : json['model'],
        'hardwareVendor': json['hardwareVendor'] == null ? undefined : json['hardwareVendor'],
        'hardwareUuid': json['hardwareUuid'] == null ? undefined : json['hardwareUuid'],
        'deviceCategory': json['deviceCategory'] == null ? undefined : json['deviceCategory'],
        'deviceSubtype': json['deviceSubtype'] == null ? undefined : json['deviceSubtype'],
        'firmwareVersion': json['firmwareVersion'] == null ? undefined : json['firmwareVersion'],
        'deviceRole': json['deviceRole'] == null ? undefined : json['deviceRole'],
        'networkDeviceConfig': json['networkDeviceConfig'] == null ? undefined : json['networkDeviceConfig'],
        'location': json['location'] == null ? undefined : json['location'],
        'geographicRegion': json['geographicRegion'] == null ? undefined : json['geographicRegion'],
        'datacenter': json['datacenter'] == null ? undefined : json['datacenter'],
        'environment': json['environment'] == null ? undefined : json['environment'],
        'owner': json['owner'] == null ? undefined : json['owner'],
        'ownerEmail': json['ownerEmail'] == null ? undefined : json['ownerEmail'],
        'department': json['department'] == null ? undefined : json['department'],
        'costCenter': json['costCenter'] == null ? undefined : json['costCenter'],
        'ownership': json['ownership'] == null ? undefined : AssetOwnershipFromJSON(json['ownership']),
        'cloudProvider': json['cloudProvider'] == null ? undefined : json['cloudProvider'],
        'cloudRegion': json['cloudRegion'] == null ? undefined : json['cloudRegion'],
        'cloudAvailabilityZone': json['cloudAvailabilityZone'] == null ? undefined : json['cloudAvailabilityZone'],
        'cloudInstanceType': json['cloudInstanceType'] == null ? undefined : json['cloudInstanceType'],
        'cloudTags': json['cloudTags'] == null ? undefined : json['cloudTags'],
        'riskScore': json['riskScore'] == null ? undefined : json['riskScore'],
        'complianceStatus': json['complianceStatus'] == null ? undefined : json['complianceStatus'],
        'lastScanDate': json['lastScanDate'] == null ? undefined : (new Date(json['lastScanDate'])),
        'criticalityLevel': json['criticalityLevel'] == null ? undefined : json['criticalityLevel'],
        'businessImpact': json['businessImpact'] == null ? undefined : json['businessImpact'],
        'compositeRiskScore': json['compositeRiskScore'] == null ? undefined : json['compositeRiskScore'],
        'riskScoreCalculatedAt': json['riskScoreCalculatedAt'] == null ? undefined : (new Date(json['riskScoreCalculatedAt'])),
        'parentAssetId': json['parentAssetId'] == null ? undefined : json['parentAssetId'],
        'systemBoundary': json['systemBoundary'] == null ? undefined : SystemBoundaryEntityFromJSON(json['systemBoundary']),
        'additionalBoundaries': json['additionalBoundaries'] == null ? undefined : (new Set((json['additionalBoundaries'] as Array<any>).map(SystemBoundaryEntityFromJSON))),
        'assetAttributes': json['assetAttributes'] == null ? undefined : json['assetAttributes'],
        'containerIds': json['containerIds'] == null ? undefined : json['containerIds'],
        'vulnerabilityIds': json['vulnerabilityIds'] == null ? undefined : json['vulnerabilityIds'],
        'active': json['active'] == null ? undefined : json['active'],
        'decommissioned': json['decommissioned'] == null ? undefined : json['decommissioned'],
    };
}

export function AssetEntityToJSON(json: any): AssetEntity {
    return AssetEntityToJSONTyped(json, false);
}

export function AssetEntityToJSONTyped(value?: AssetEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'discoveredAt': value['discoveredAt'] == null ? undefined : ((value['discoveredAt']).toISOString()),
        'lastSeenAt': value['lastSeenAt'] == null ? undefined : ((value['lastSeenAt']).toISOString()),
        'decommissionedAt': value['decommissionedAt'] == null ? undefined : ((value['decommissionedAt']).toISOString()),
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'status': value['status'],
        'version': value['version'],
        'extendedAttributes': value['extendedAttributes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'goldenRecordId': value['goldenRecordId'],
        'openVulnCount': value['openVulnCount'],
        'openVulnCritical': value['openVulnCritical'],
        'openVulnHigh': value['openVulnHigh'],
        'openVulnMedium': value['openVulnMedium'],
        'openVulnLow': value['openVulnLow'],
        'openVulnCountUpdatedAt': value['openVulnCountUpdatedAt'] == null ? undefined : ((value['openVulnCountUpdatedAt']).toISOString()),
        'openWeaknessCount': value['openWeaknessCount'],
        'openWeaknessCritical': value['openWeaknessCritical'],
        'openWeaknessHigh': value['openWeaknessHigh'],
        'openWeaknessMedium': value['openWeaknessMedium'],
        'openWeaknessLow': value['openWeaknessLow'],
        'openWeaknessCountUpdatedAt': value['openWeaknessCountUpdatedAt'] == null ? undefined : ((value['openWeaknessCountUpdatedAt']).toISOString()),
        'serialNumber': value['serialNumber'],
        'assetTag': value['assetTag'],
        'externalId': value['externalId'],
        'cloudInstanceId': value['cloudInstanceId'],
        'cloudResourceId': value['cloudResourceId'],
        'ipAddresses': value['ipAddresses'],
        'macAddresses': value['macAddresses'],
        'hostname': value['hostname'],
        'hostnames': value['hostnames'],
        'fqdn': value['fqdn'],
        'dnsNames': value['dnsNames'],
        'name': value['name'],
        'displayName': value['displayName'],
        'description': value['description'],
        'assetType': value['assetType'],
        'cloudResourceType': value['cloudResourceType'],
        'cloudServiceKind': value['cloudServiceKind'],
        'cloudServiceConfig': value['cloudServiceConfig'],
        'applicationGroupId': value['applicationGroupId'],
        'hierarchyPath': value['hierarchyPath'],
        'saasTenantId': value['saasTenantId'],
        'saasSubscriptionId': value['saasSubscriptionId'],
        'saasEdition': value['saasEdition'],
        'saasLicenseCount': value['saasLicenseCount'],
        'saasServiceType': value['saasServiceType'],
        'osName': value['osName'],
        'osVersion': value['osVersion'],
        'osFamily': value['osFamily'],
        'architecture': value['architecture'],
        'manufacturer': value['manufacturer'],
        'model': value['model'],
        'hardwareVendor': value['hardwareVendor'],
        'hardwareUuid': value['hardwareUuid'],
        'deviceCategory': value['deviceCategory'],
        'deviceSubtype': value['deviceSubtype'],
        'firmwareVersion': value['firmwareVersion'],
        'deviceRole': value['deviceRole'],
        'networkDeviceConfig': value['networkDeviceConfig'],
        'location': value['location'],
        'geographicRegion': value['geographicRegion'],
        'datacenter': value['datacenter'],
        'environment': value['environment'],
        'owner': value['owner'],
        'ownerEmail': value['ownerEmail'],
        'department': value['department'],
        'costCenter': value['costCenter'],
        'ownership': AssetOwnershipToJSON(value['ownership']),
        'cloudProvider': value['cloudProvider'],
        'cloudRegion': value['cloudRegion'],
        'cloudAvailabilityZone': value['cloudAvailabilityZone'],
        'cloudInstanceType': value['cloudInstanceType'],
        'cloudTags': value['cloudTags'],
        'riskScore': value['riskScore'],
        'complianceStatus': value['complianceStatus'],
        'lastScanDate': value['lastScanDate'] == null ? undefined : ((value['lastScanDate']).toISOString()),
        'criticalityLevel': value['criticalityLevel'],
        'businessImpact': value['businessImpact'],
        'compositeRiskScore': value['compositeRiskScore'],
        'riskScoreCalculatedAt': value['riskScoreCalculatedAt'] == null ? undefined : ((value['riskScoreCalculatedAt']).toISOString()),
        'parentAssetId': value['parentAssetId'],
        'systemBoundary': SystemBoundaryEntityToJSON(value['systemBoundary']),
        'additionalBoundaries': value['additionalBoundaries'] == null ? undefined : (Array.from(value['additionalBoundaries'] as Set<any>).map(SystemBoundaryEntityToJSON)),
        'assetAttributes': value['assetAttributes'],
        'containerIds': value['containerIds'],
        'vulnerabilityIds': value['vulnerabilityIds'],
        'active': value['active'],
        'decommissioned': value['decommissioned'],
    };
}

